import type { UserSourcesResponseDto } from '@lunary/api-client'
import { USER_SOURCE_LABELS, formatDateTime } from './labels'
import { useUserSources } from './queries'
import styles from './user-card.module.css'

type Source = UserSourcesResponseDto['items'][number]

function SourceLink({ source }: { source: Source }) {
  if (source.url) {
    const text = source.username ? `@${source.username}` : `id ${source.external_id}`
    return (
      <a href={source.url} target="_blank" rel="noopener noreferrer">
        {text}
      </a>
    )
  }
  if (source.email) return <a href={`mailto:${source.email}`}>{source.email}</a>
  return <span>id {source.external_id}</span>
}

function sourceMeta(source: Source): string {
  const linked = `привязан ${formatDateTime(source.linked_at)}`
  return source.url || !source.email ? linked : `id ${source.external_id}, ${linked}`
}

export function UserSources({ userId }: { userId: string }) {
  const sources = useUserSources(userId)
  return (
    <section className="card-panel" aria-labelledby="user-sources-title">
      <h2 id="user-sources-title">Источники</h2>
      {sources.isPending && <div className="spinner" aria-label="Загрузка" />}
      {sources.isError && <p className="error-box">Не удалось загрузить источники.</p>}
      {sources.data && sources.data.items.length === 0 && <p className="muted">Нет привязанных источников.</p>}
      {sources.data && sources.data.items.length > 0 && (
        <dl className={styles.facts}>
          {sources.data.items.map((source) => (
            <div key={`${source.provider}:${source.external_id}`} className={styles.fact}>
              <dt className="muted">{USER_SOURCE_LABELS[source.provider] ?? source.provider}</dt>
              <dd className={styles.sourceValue}>
                <SourceLink source={source} />
                <span className={`muted ${styles.sourceMeta}`}>{sourceMeta(source)}</span>
              </dd>
            </div>
          ))}
        </dl>
      )}
    </section>
  )
}
